import React, {useState} from 'react';

import {Button} from '@components';
import {Props} from './types';
import _Base from './../_Base';

import * as handlers from './handlers';

import './index.scss';

const UpdateAuthority: React.FC<Props> = props => {
  const [loading, setLoading] = useState(false);

  return (
    <_Base
      isModal={props.isModal}
      handleCloseModal={props.handleCloseModal}
      size="xs"
      title="権限変更"
    >
      <div className="w__authority-modal">
        <div className="w__message">
          <div>
            選択したユーザーの権限を管理者に変更するためのメールを送信します。
          </div>
          <div>管理者になったユーザーはログインする事ができます。</div>
        </div>
        <div className="w__buttons">
          <Button.Normal
            text="キャンセル"
            onClick={() => props.handleCloseModal(false)}
          />
          <Button.Normal
            onClick={async () => {
              await handlers.submit(
                props.email,
                props.id,
                setLoading,
                props.actions,
                props.handleCloseModal,
                props.history
              );
            }}
            disabled={loading}
            loading={loading}
            color="yellow"
          >
            変更する
          </Button.Normal>
        </div>
      </div>
    </_Base>
  );
};

export default UpdateAuthority;
